
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/gdpr.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from '@hooks/useRouter';
import * as actions from '@actions';
import { FaRegCheckCircle } from 'react-icons/fa';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import Header from '@components/Layouts/Header/Header';

const StyledGDPRPage = styled.div`
  .login-header {
    border-bottom: 1px solid #707070;

    .nav-panel {
      display: none !important;
    }
  }

  .title {
    font-weight: 600;
    font-size: 25px;
    margin-top: 25px;
    margin-bottom: 50px;
  }

  .center-grid {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    place-items: center;
  }

  .login-layout {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 75px + var(--footer-height, 50px));
    font-family: 'Montserrat';
    background: #fff;

    @media (max-width: 768px) {
      height: unset;
    }
  }

  .login-bottom {
    position: relative;
    width: 100%;
    padding: 21px;
    background: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    border-top: 1px solid #707070;

    @media (max-width: 600px) {
      display: none;
    }
  }
`;

function ConfirmGDPR() {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState<boolean | null>(null);
  const router = useRouter();
  const { t } = useTranslation();
  const { token } = router.query;

  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(actions.confirmGDPR(token));

      setSuccess('token' in res);
    };
    if (token) {
      fetchData().then();
    }
  }, [dispatch, token]);

  return (
    <StyledGDPRPage>
      <Header pageType="login" className="login-header" pageTitle="Confirm GDPR" />
      <section className="section-layout login-layout">
        <br />
        {success && (
          <div className="center-grid">
            <FaRegCheckCircle style={{ fontSize: 100 }} />
            <h1 className="title">
              <span className="orange">{t('GDPR Confirmation')}</span> {t('Successful')}
            </h1>
            <Button style={{ width: 200, marginTop: 50 }} onClick={() => router.push('/login')} data-testid="login">
              {t('Login')}
            </Button>
          </div>
        )}
        {success === null && (
          <div className="center-grid" style={{ fontSize: 30, color: '#db6f20' }}>
            <h1 className="title">
              <span className="orange">{t('GDPR Confirmation')}</span>
              {t('in flight')}
            </h1>
          </div>
        )}
        {success === false && (
          <div className="center-grid" style={{ fontSize: 30, color: '#db6f20' }}>
            <h1 className="title">
              <span className="orange">{t('GDPR Confirmation')}</span>
              {t('Failed')}
              <br />
              {t('Please notify you administrator')}.
            </h1>
          </div>
        )}
      </section>
    </StyledGDPRPage>
  );
}


export const Route = createFileRoute('/gdpr')({ component: ConfirmGDPR });
